<template>
  <CFooter :fixed="true">
    <div>
      <a href="https://hnc.co.ke" target="_blank">HNC</a>
      <span class="ml-1"
        >&copy; {{ new Date().getFullYear() }} HNC Advocates - DBMS.</span
      >
    </div>
    <div class="mfs-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://coreui.io/vue" target="_blank">CoreUI for Vue</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
